//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
let d=[[[0,"BuildStatus",0,0],[0,"DesignStatus",1,0],[0,"DisplayStatus",1,0],[1,"MinimumCavityDepth",0,"Expression",0],[1,"MinimumExtensionLength",0,"Expression",0]],[[["minimum_extension_length"],"SetMinimumExtensionLength",{},1,0],[["minimum_cavity_depth"],"SetMinimumCavityDepth",{},1,0],[["title","value","color"],"GetRotorAttributes",{},0,0],[["title","value","color"],"SetRotorAttributes",{},3,0],[["title","value","color"],"GetFormingAttributes",{},0,0],[["title","value","color"],"SetFormingAttributes",{},3,0],[["title","value","color"],"GetFlangeWallAttributes",{},0,0],[["title","value","color"],"SetFlangeWallAttributes",{},3,0],[["title","value","color"],"GetEndAttributes",{},0,0],[["title","value","color"],"SetEndAttributes",{},3,0]],[]];
SPLM.Die.RotorSectionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.RotorSectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;